var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticStyle: { "text-align": "left" } },
        [
          _c(
            "el-button",
            {
              staticStyle: { "flex-grow": "1" },
              attrs: { no: "1", type: "primary", disabled: _vm.isEdit },
              on: { click: _vm.addDetailHandler }
            },
            [_vm._v(_vm._s(_vm.$t("Warehouse.AddCargo")))]
          ),
          _c(
            "el-button",
            {
              staticStyle: { "flex-grow": "1" },
              attrs: { no: "2", type: "danger", disabled: _vm.isEdit },
              on: { click: _vm.delDetailHandler }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.DeleteGoods")))]
          )
        ],
        1
      ),
      _c("cargo-ag-grid", {
        staticStyle: { height: "300px", "margin-top": "10px" },
        attrs: {
          no: "grid",
          "config-module": _vm.gridConfigModule,
          "grid-options": _vm.gridOptions,
          "column-defs": _vm.columnDefs,
          "row-data": _vm.rowData,
          "auto-fit-content": false
        },
        on: {
          gridReady: function(params) {
            _vm.gridApi = params.api
          }
        }
      }),
      _vm.displaySummary
        ? _c(
            "el-form",
            {
              staticStyle: { "margin-right": "10px" },
              attrs: { "label-width": "100px", "label-position": "left" }
            },
            [
              _c(
                "div",
                [
                  _c("el-form-item", { staticClass: "auto-width" }, [
                    _c(
                      "div",
                      {
                        staticClass: "title-row",
                        staticStyle: { display: "flex", "text-align": "left" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "font-size": "12px",
                              "font-weight": "normal",
                              color: "#404144",
                              "white-space": "nowrap",
                              width: "130px",
                              "text-align": "right"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.Quantity")))]
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "font-size": "12px",
                              "font-weight": "normal",
                              color: "#404144",
                              "white-space": "nowrap",
                              width: "130px",
                              "text-align": "right"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.Weight")) +
                                " " +
                                _vm._s(_vm.openImperial ? "LB" : "KGS")
                            )
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "font-size": "12px",
                              "font-weight": "normal",
                              color: "#404144",
                              "white-space": "nowrap",
                              width: "130px",
                              "text-align": "right"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.Cubage")) +
                                " " +
                                _vm._s(_vm.openImperial ? "CFT" : "CBM")
                            )
                          ]
                        )
                      ]
                    )
                  ]),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      attrs: { label: _vm.$t("SeaExport.Actual") }
                    },
                    [
                      _c("el-input-number", {
                        attrs: {
                          no: "3",
                          value: _vm.warehouseIn.quantitySum || undefined,
                          disabled: true,
                          "controls-position": "right",
                          min: 0,
                          max: 999999999,
                          precision: 0
                        },
                        on: {
                          input: function(val) {
                            _vm.warehouseIn.quantitySum = val
                          }
                        }
                      }),
                      _c("el-input-number", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.openImperial,
                            expression: "openImperial"
                          }
                        ],
                        attrs: {
                          no: "4",
                          value: _vm.warehouseIn.weightSumImperial || undefined,
                          disabled: true,
                          "controls-position": "right",
                          precision: 2,
                          min: 0,
                          max: 999999999
                        },
                        on: {
                          input: function(val) {
                            _vm.warehouseIn.weightSumImperial = val
                          }
                        }
                      }),
                      _c("el-input-number", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.openImperial,
                            expression: "openImperial"
                          }
                        ],
                        attrs: {
                          no: "5",
                          value: _vm.warehouseIn.cubAgeSumImperial || undefined,
                          disabled: true,
                          "controls-position": "right",
                          precision: 3,
                          min: 0,
                          max: 999999999
                        },
                        on: {
                          input: function(val) {
                            _vm.warehouseIn.cubAgeSumImperial = val
                          }
                        }
                      }),
                      _c("el-input-number", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.openImperial,
                            expression: "!openImperial"
                          }
                        ],
                        attrs: {
                          no: "4",
                          value: _vm.warehouseIn.weightSum || undefined,
                          disabled: true,
                          "controls-position": "right",
                          precision: 2,
                          min: 0,
                          max: 999999999
                        },
                        on: {
                          input: function(val) {
                            _vm.warehouseIn.weightSum = val
                          }
                        }
                      }),
                      _c("el-input-number", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.openImperial,
                            expression: "!openImperial"
                          }
                        ],
                        attrs: {
                          no: "5",
                          value: _vm.warehouseIn.cubageSum || undefined,
                          disabled: true,
                          "controls-position": "right",
                          precision: 3,
                          min: 0,
                          max: 999999999
                        },
                        on: {
                          input: function(val) {
                            _vm.warehouseIn.cubageSum = val
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      attrs: { label: _vm.$t("SeaExport.Consignation") }
                    },
                    [
                      _c("el-input-number", {
                        attrs: {
                          no: "6",
                          value: _vm.job.quantityContract || undefined,
                          disabled: true,
                          "controls-position": "right",
                          min: 0,
                          max: 999999999,
                          precision: 0
                        },
                        on: {
                          input: function(val) {
                            _vm.job.quantityContract = val
                          }
                        }
                      }),
                      _c("el-input-number", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.openImperial,
                            expression: "openImperial"
                          }
                        ],
                        attrs: {
                          no: "7",
                          value: _vm.job.weightContractImperial || undefined,
                          disabled: true,
                          "controls-position": "right",
                          precision: 2,
                          min: 0,
                          max: 999999999
                        },
                        on: {
                          input: function(val) {
                            _vm.job.weightContractImperial = val
                          }
                        }
                      }),
                      _c("el-input-number", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.openImperial,
                            expression: "openImperial"
                          }
                        ],
                        attrs: {
                          no: "8",
                          value: _vm.job.cubAgeContractImperial || undefined,
                          disabled: true,
                          "controls-position": "right",
                          precision: 3,
                          min: 0,
                          max: 999999999
                        },
                        on: {
                          input: function(val) {
                            _vm.job.cubAgeContractImperial = val
                          }
                        }
                      }),
                      _c("el-input-number", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.openImperial,
                            expression: "!openImperial"
                          }
                        ],
                        attrs: {
                          no: "7",
                          value: _vm.job.weightContract || undefined,
                          disabled: true,
                          "controls-position": "right",
                          precision: 2,
                          min: 0,
                          max: 999999999
                        },
                        on: {
                          input: function(val) {
                            _vm.job.weightContract = val
                          }
                        }
                      }),
                      _c("el-input-number", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.openImperial,
                            expression: "!openImperial"
                          }
                        ],
                        attrs: {
                          no: "8",
                          value: _vm.job.cubageContract || undefined,
                          disabled: true,
                          "controls-position": "right",
                          precision: 3,
                          min: 0,
                          max: 999999999
                        },
                        on: {
                          input: function(val) {
                            _vm.job.cubageContract = val
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }